// Mobile overlay
function openOverlay() {
  document.getElementById('mobile-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeOverlay() {
  document.getElementById('mobile-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

// FAQ accordion
function toggleFaq(btn) {
  const item = btn.parentElement;
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach(el => el.classList.remove('open'));
  if (!isOpen) item.classList.add('open');
}

// Scroll fade-in observer
const fadeObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
    }
  });
}, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

// ── Cart Drawer ──────────────────────────────────────────────

function openCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  drawer.classList.add('open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  loadCartDrawer();
}

function closeCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  drawer.classList.remove('open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

function loadCartDrawer() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const itemsEl = document.getElementById('cart-drawer-items');
      const totalEl = document.getElementById('cart-drawer-total');

      if (!itemsEl) return;

      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<p class="cart-empty">Handlekurven er tom 🛒</p>';
      } else {
        itemsEl.innerHTML = cart.items.map(item => `
          <div class="cart-drawer-item">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" class="cart-item-img" width="72" height="72" loading="lazy">` : '<div class="cart-item-img-placeholder"></div>'}
            <div class="cart-item-info">
              <p class="cart-item-title">${item.title}</p>
              ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item-variant">${item.variant_title}</p>` : ''}
              <div class="cart-item-qty-row">
                <button class="cart-qty-btn" onclick="updateCartItem(${item.key}, ${item.quantity - 1})" aria-label="Minsk">−</button>
                <span class="cart-item-qty">${item.quantity}</span>
                <button class="cart-qty-btn" onclick="updateCartItem(${item.key}, ${item.quantity + 1})" aria-label="Øk">+</button>
              </div>
            </div>
            <span class="cart-item-price">${(item.final_line_price / 100).toFixed(0)} kr</span>
          </div>
        `).join('');
      }

      if (totalEl) totalEl.textContent = (cart.total_price / 100).toFixed(0) + ' kr';

      const badge = document.querySelector('.cart-badge');
      if (badge) badge.textContent = cart.item_count || '';
    })
    .catch(() => {
      const itemsEl = document.getElementById('cart-drawer-items');
      if (itemsEl) itemsEl.innerHTML = '<p class="cart-empty">Kunne ikke laste handlekurven.</p>';
    });
}

function updateCartItem(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(() => loadCartDrawer())
  .catch(console.error);
}

function addToCartAndOpen(variantId, quantity) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: quantity || 1 })
  })
  .then(r => r.json())
  .then(() => openCartDrawer())
  .catch(err => {
    console.error('Add to cart failed:', err);
    // Fallback: open cart page
    window.location.href = '/cart';
  });
}

// ── Init ─────────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.fade-in').forEach(el => fadeObserver.observe(el));

  // Intercept buy buttons with data-buy-btn attribute
  document.querySelectorAll('[data-buy-btn]').forEach(btn => {
    btn.addEventListener('click', function(e) {
      const variantId = this.dataset.variantId;
      if (variantId) {
        e.preventDefault();
        addToCartAndOpen(variantId, 1);
      } else {
        // No variant ID set – open drawer showing current cart
        e.preventDefault();
        openCartDrawer();
      }
    });
  });

  // Hero primary button also opens drawer if it points to a product
  document.querySelectorAll('a[href*="/products/"]').forEach(link => {
    if (link.classList.contains('btn-primary')) {
      link.addEventListener('click', function(e) {
        // Only intercept if we have variant info; otherwise let Shopify handle it
        // Add data-variant-id to the hero btn in the schema to enable this
        const variantId = this.dataset.variantId;
        if (variantId) {
          e.preventDefault();
          addToCartAndOpen(variantId, 1);
        }
      });
    }
  });

  // Update cart badge on load
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const badge = document.querySelector('.cart-badge');
      if (badge) badge.textContent = cart.item_count || '';
    })
    .catch(() => {});
});
